import React, {Component} from 'react';
import {FormattedMessage} from "react-intl";
import "./ManufactureDocument.css";
import newm1 from '../../../../../../assets/img/newm1.png';
import newm2 from '../../../../../../assets/img/newm2.png';
import newm3 from '../../../../../../assets/img/newm3.png';
import newm4 from '../../../../../../assets/img/newm4.png';
import newm5 from '../../../../../../assets/img/newm5.png';
import newm6 from '../../../../../../assets/img/newm6.png';
import newm7 from '../../../../../../assets/img/newm7.png';
import newm8 from '../../../../../../assets/img/newm8.png';
import newm9 from '../../../../../../assets/img/newm9.png';
import newm10 from '../../../../../../assets/img/newm10.png';
import newm11 from '../../../../../../assets/img/newm11.png';
import newm12 from '../../../../../../assets/img/newm12.png';
import newm13 from '../../../../../../assets/img/newm13.png';
import newm14 from '../../../../../../assets/img/newm14.png';
import newm15 from '../../../../../../assets/img/newm15.png';
import newm16 from '../../../../../../assets/img/newm16.png';
import newm17 from '../../../../../../assets/img/newm17.png';
import KINGBOARD from '../../../../../../assets/files/KINGBOARD FR-4 Materials Certifications.zip'
import ipc from '../../../../../../assets/img/ipc.png'
import ul from '../../../../../../assets/img/ul.jpg'
import NanYa from '../../../../../../assets/files/Nan Ya-ROHS Test Report.zip'
import {Link} from "react-router-dom";
import MetaTags from "react-meta-tags";


class ManufactureDocument extends Component {

    componentDidMount() {
        window.scrollTo(0, 0);

    }

    render() {
        return (

            <div className="static-pages">
                <MetaTags>
                    <title>基板製造基準｜プリント基板のネット通販｜KITCUT PCB</title>
                    <meta property="title" content="基板製造基準｜プリント基板のネット通販｜KITCUT PCB"/>
                    <meta name="title" content="基板製造基準｜プリント基板のネット通販｜KITCUT PCB"/>
                    <meta property="description" content="プリント基板のネット通販 KITCUT PCBのプリント基板製造サービス、１枚から量産価格！今すぐ見積スタート、WEBで簡単に見積・注文が可能で生産状況をリアルタイムで表示。" lang="ja" />
                    <meta name="description" content="プリント基板のネット通販 KITCUT PCBのプリント基板製造サービス、１枚から量産価格！今すぐ見積スタート、WEBで簡単に見積・注文が可能で生産状況をリアルタイムで表示。" lang="ja" />
                </MetaTags>
                <div className="background-div">

                    <div className="row">

                        <div className="resp-heading-static">
                            <h3>
                                <b>
                                    <FormattedMessage id="app.image-slider.quotation.manufacture.document"
                                                      defaultMessage="基板製造基準"
                                                      description=""/>
                                </b>
                            </h3>
                        </div>

                        <div>
                            <ol>
                                <li className='all-content-font-size-padding-bottom all-content-font-size'>
                                    {/*<FormattedMessage id="app.image-slider.quotation.manufacture.scope"*/}
                                    {/*defaultMessage="適用範囲*/}
                                    {/*本基準書はRIZEN HK LIMITEDによって運営されるプリント基板ネット通販「Kitcutlabo.com（キットカットラボドットコ*/}
                                    {/*ム）」にて販売する"*/}
                                    {/*description=""/>*/}
                                    {/*<br/>*/}
                                    {/*リジットプリント配線板に適用します。*/}

                                    適用範囲本基準書はRIZEN HK
                                    LIMITEDによって運営されるプリント基板ネット通販「Kitcutlabo.com（キットカットラボドットコム）」にて販売するリジットプリント配線板に適用します。

                                </li>
                                <li className='all-content-font-size-padding-bottom all-content-font-size'>
                                    <FormattedMessage id="app.image-slider.quotation.manufacture.overview"
                                                      defaultMessage="製造仕様概要Kitcutlabo.comにて提供する片面 ～ 6 層基板の共通仕様"
                                                      description=""/>
                                </li>
                                <li className='all-content-font-size-padding-bottom all-content-font-size'>
                                    {/*<FormattedMessage id="app.image-slider.quotation.manufacture.concept"*/}
                                    {/*defaultMessage="製造コストの考え方、製造枚数、製造仕様（基材、層数、シルク等）可能な限りの仕様共通化を図り*/}
                                    {/*環境を整備することによって最終製造コストの"*/}
                                    {/*description=""/>*/}
                                    {/*<br/>*/}
                                    {/*削減に努力いたします。*/}


                                    製造コストの考え方、製造枚数、製造仕様（基材、層数、シルク等）可能な限りの仕様共通化を図り環境を整備することによって最終製造コストの
                                    削減に努力いたします。
                                </li>
                                <li className='all-content-font-size-padding-bottom all-content-font-size'>
                                    <FormattedMessage id="app.image-slider.quotation.manufacture4"
                                                      defaultMessage="プリント回路基板業界認証UL認定工場"
                                                      description=""/>
                                    &nbsp;&nbsp; <img src={ul} alt="ul" className="ul-image"/>
                                </li>
                                <li className='all-content-font-size-padding-bottom all-content-font-size'>
                                    <FormattedMessage id="app.image-slider.quotation.manufacture5"
                                                      defaultMessage="IPC"
                                                      description=""/>
                                    <a href="http://www.ipc.org/ContentPage.aspx?pageid=IPC-Fact-Sheet-Japanese">（米国電子回路協会会員企業）</a>

                                    &nbsp;&nbsp; <img src={ipc} alt="ipc" className="ipc-image"/>
                                </li>
                                <li className='all-content-font-size-padding-bottom all-content-font-size'>
                                    <FormattedMessage id="app.image-slider.quotation.manufacture6"
                                                      defaultMessage="基礎材料の認定　"
                                                      description=""/>
                                    <p>&nbsp;KINGBOARD FR-4の材料認証： <a href={KINGBOARD}>こちら</a> ダウンロードしてください。<br/>
                                        &nbsp;Nan Ya Materials - ROHSテストレポート： <a href={NanYa}>こちら</a>からダウンロードしてください。</p>
                                </li>
                            </ol>
                        </div>

                    </div>

                    <div className="row table-div overFlow-table ">
                        <div className="col-md-12 table-block-manufacture">
                            <table border="1">
                                <tr>
                                    <td className="td-div2 col-md-2">
                                        <FormattedMessage id="app.image-slider.quotation.manufacture.item"
                                                          defaultMessage="項目"
                                                          description=""/>
                                    </td>
                                    <td className="td-div2 custom-col-manufacture-1">
                                        <FormattedMessage id="app.image-slider.quotation.manufacture.standard"
                                                          defaultMessage="基準"
                                                          description=""/>
                                    </td>
                                    <td className="td-div1 custom-col-manufacture-2  set-padding-manufacture-web">
                                        <FormattedMessage id="app.image-slider.quotation.manufacture.details"
                                                          defaultMessage="詳細"
                                                          description=""/>
                                    </td>
                                    <td className="td-div col-md-3">
                                        {/*<FormattedMessage id="app.image-slider.quotation.manufacture."*/}
                                        {/*defaultMessage=""*/}
                                        {/*description=""/>*/}
                                    </td>
                                </tr>

                                <tr>
                                    <td className="td-div2 col-md-2">
                                        <p>基材</p>
                                    </td>
                                    <td className="td-div2 custom-col-manufacture-1">
                                        <p>FR-4</p>
                                    </td>
                                    <td className="td-div1 custom-col-manufacture-2  set-padding-manufacture-web">
                                        <p>ガラス布エポキシ樹脂胴張積層板</p>
                                    </td>
                                    <td className="td-div col-md-3">
                                        <div>
                                            <p>KINGBOARD FR-4材料認定証</p>
                                        </div>
                                        <div>
                                            <img src={newm1} className="image-size"/>
                                        </div>
                                    </td>
                                </tr>

                                <tr>
                                    <td className="td-div2 col-md-2">
                                        <p>層数</p>
                                    </td>
                                    <td className="td-div2 custom-col-manufacture-1">
                                        <p>1層 ～ 6層</p>
                                    </td>
                                    <td className="td-div1 custom-col-manufacture-2  set-padding-manufacture-web">
                                        <p>１層 ～ 6層まで試作基板製作</p>
                                    </td>
                                    <td className="td-div col-md-3">
                                        <p>受注枚数選択式</p>
                                    </td>
                                </tr>

                                <tr>
                                    <td className="td-div2 col-md-2">
                                        <p>インピーダンス制御</p>
                                    </td>
                                    <td className="td-div2 custom-col-manufacture-1">
                                        <p>4層/6層</p>
                                    </td>
                                    <td className="td-div1 custom-col-manufacture-2  set-padding-manufacture-web">
                                        <p>デフォルトのみのスタックアップ対応<br/>7628：誘導率4.6 <br/>2313：誘導率4.05<br/>※現在6層基板は2313のみ提供対応"
                                        </p>
                                    </td>
                                    <td className="td-div col-md-3">
                                        {/*<FormattedMessage id="app.image-slider.quotation.manufacture.image-impedance"*/}
                                        {/*defaultMessage="インピーダンス制御スタックアップ*/}
                                        {/*インピーダンス計算機"*/}
                                        {/*description=""/>*/}
                                    </td>
                                </tr>

                                <tr>
                                    <td className="td-div2 col-md-2">
                                        <p>最大製造寸法</p>
                                    </td>
                                    {/*<td className="td-div2 custom-col-manufacture-1">*/}
                                    {/*<p>400mm×500mm</p>*/}
                                    {/*</td>*/}
                                    {/*<td className="td-div1 custom-col-manufacture-2  set-padding-manufacture-web">*/}
                                    {/*<p>片面/両面基板：400mm×500mm<br/>4層/6層基板：390mm×390mm"</p>*/}
                                    {/*</td>*/}
                                    <td className="td-div2 custom-col-manufacture-1">
                                        <p>片面・両面・4層・6層基板
                                            <br/>
                                            400mm×500mm</p>
                                    </td>
                                    <td className="td-div1 custom-col-manufacture-2  set-padding-manufacture-web">
                                        <p>Vカットによるシート面付の場合
                                            <br/>
                                       最小サイズ70mm×70mm以上
                                            <br/>
                                      最大サイズ400mm×400mmです。</p>
                                    </td>
                                    <td className="td-div col-md-3">
                                        {/*<FormattedMessage id="app.image-slider.quotation.manufacture."*/}
                                        {/*defaultMessage=""*/}
                                        {/*description=""/>*/}
                                    </td>
                                </tr>

                                <tr>
                                    <td className="td-div2 col-md-2">
                                        <p>寸法公差</p>
                                    </td>
                                    <td className="td-div2 custom-col-manufacture-1">
                                        <p>±0.2mm外形加工、Vカット</p>
                                    </td>
                                    <td className="td-div1 custom-col-manufacture-2  set-padding-manufacture-web">
                                        <p>100mm以下±0.2mm 100mm以上50mmまでの<br/>寸法増加ごとに0.1mmを加える</p>
                                    </td>
                                    <td className="td-div col-md-3">
                                        {/*<FormattedMessage id="app.image-slider.quotation.manufacture."*/}
                                        {/*defaultMessage=""*/}
                                        {/*description=""/>*/}
                                    </td>
                                </tr>

                                <tr>
                                    <td className="td-div2 col-md-2">
                                        <p>レジストカラー</p>
                                    </td>
                                    <td className="td-div2 custom-col-manufacture-1">
                                        <p>緑、赤、黄、<br/>青、白、黒</p>
                                        {/*<p> &nbsp;&nbsp;&nbsp;緑、赤、黄、<br/>青、白、黒</p>*/}
                                    </td>
                                    <td className="td-div1 custom-col-manufacture-2  set-padding-manufacture-web">
                                        <p>現像型ソルダーレジストプリント配線板に露光現<br/>像することにより微細な回路パターンを形成する<br/>ことが可能なレジストインキ。</p>
                                    </td>
                                    <td className="td-div2 col-md-3 register-manufac">
                                        <div>
                                            <p>レジストカラー<br/>緑、赤、黄、青、黒を選択した場合、シルクは白色。<br/>白レジストを選択した場合シルクは黒色。
                                            </p>
                                        </div>
                                        <div>
                                            <img src={newm2} className="image-size"/>
                                        </div>
                                    </td>
                                </tr>

                                <tr>
                                    <td className="td-div2 col-md-2">
                                        <p>板厚</p>
                                    </td>
                                    <td className="td-div2 custom-col-manufacture-1">
                                        <p>0.4mm～2.0mm</p>
                                    </td>
                                    <td className="td-div1 custom-col-manufacture-2  set-padding-manufacture-web">
                                        <p>0.4/0.6/0.8/1.0/1.2/1.6/2.0mm</p>
                                    </td>
                                    <td className="td-div col-md-3">
                                        {/*<FormattedMessage id="app.image-slider.quotation.manufacture."*/}
                                        {/*defaultMessage=""*/}
                                        {/*description=""/>*/}
                                    </td>
                                </tr>

                                <tr>
                                    <td className="td-div2 col-md-2">
                                        <p>板厚公差（T≧1.0mm）</p>
                                    </td>
                                    <td className="td-div2 custom-col-manufacture-1">
                                        <p>1.0、1.2、1.6、2.0mm±10％</p>
                                    </td>
                                    <td className="td-div1 custom-col-manufacture-2  set-padding-manufacture-web">
                                        <p>例）<br/>板厚1.6mmの場合1.44mmから1.76mmの範囲です。</p>
                                    </td>
                                    <td className="td-div col-md-3">
                                        {/*<FormattedMessage id="app.image-slider.quotation.manufacture."*/}
                                        {/*defaultMessage=""*/}
                                        {/*description=""/>*/}
                                    </td>
                                </tr>

                                <tr>
                                    <td className="td-div2 col-md-2">
                                        <p>板厚公差（T≦1.0mm）</p>
                                    </td>
                                    <td className="td-div2 custom-col-manufacture-1">
                                        <p>0.4/0.6/0.8mm ±0.1mm</p>
                                    </td>
                                    <td className="td-div1 custom-col-manufacture-2  set-padding-manufacture-web">
                                        <p>例）<br/>板厚0.8mmの場合0.7mmから0.9mmの範囲です。</p>
                                    </td>
                                    <td className="td-div col-md-3">
                                        {/*<FormattedMessage id="app.image-slider.quotation.manufacture."*/}
                                        {/*defaultMessage=""*/}
                                        {/*description=""/>*/}
                                    </td>
                                </tr>

                                <tr>
                                    <td className="td-div2 col-md-2">
                                        <p>外層銅箔厚</p>
                                    </td>
                                    <td className="td-div2 custom-col-manufacture-1">
                                        <p>35μ/70μ</p>
                                    </td>
                                    <td className="td-div1 custom-col-manufacture-2  set-padding-manufacture-web">
                                        <p>35μ最小パターン幅：0.127mm以上 <br/> 70μ最小パターン幅：0.15mm以上</p>
                                    </td>
                                    <td className="td-div col-md-3">
                                        {/*<FormattedMessage id="app.image-slider.quotation.manufacture."*/}
                                        {/*defaultMessage=""*/}
                                        {/*description=""/>*/}
                                        <div>
                                            <img src={newm3} className="image3-size"/>
                                        </div>
                                    </td>
                                </tr>

                                <tr>
                                    <td className="td-div2 col-md-2">
                                        <p>内層銅箔厚</p>
                                    </td>
                                    <td className="td-div2 custom-col-manufacture-1">
                                        <p>17μ</p>
                                    </td>
                                    <td className="td-div1 custom-col-manufacture-2  set-padding-manufacture-web">
                                        <p>17μ最小パターン幅：0.075mm以上</p>
                                    </td>
                                    <td className="td-div col-md-3">
                                        {/*<FormattedMessage id="app.image-slider.quotation.manufacture."*/}
                                        {/*defaultMessage=""*/}
                                        {/*description=""/>*/}
                                        <div>
                                            <img src={newm4} className="image-size"/>
                                        </div>
                                    </td>
                                </tr>

                                <tr>
                                    <td className="td-div2 col-md-2">
                                        <p>最小パターン幅</p>
                                    </td>
                                    <td className="td-div2 custom-col-manufacture-1">
                                        <p>0.08mm</p>
                                    </td>
                                    <td className="td-div1 custom-col-manufacture-2  set-padding-manufacture-web">
                                        <p>片面、両面基板の場合、最小パターン幅 0.127mm多層基板の場合、最小パターン幅0.08mm</p>
                                    </td>
                                    <td className="td-div col-md-3">
                                        {/*<FormattedMessage id="app.image-slider.quotation.manufacture."*/}
                                        {/*defaultMessage=""*/}
                                        {/*description=""/>*/}
                                        <div>
                                            <img src={newm5} className="image-size"/>
                                        </div>
                                    </td>
                                </tr>

                                <tr>
                                    <td className="td-div2 col-md-2">
                                        <p>最小パターン間隔</p>
                                    </td>
                                    <td className="td-div2 custom-col-manufacture-1">
                                        <p>0.08mm</p>
                                    </td>
                                    <td className="td-div1 custom-col-manufacture-2  set-padding-manufacture-web">
                                        <p>片面、両面基板の場合<br/>最小パターン間 隔0.127mm<br/><br/>多層基板の場合<br/>最小パターン間隔0.08mm</p>
                                    </td>
                                    <td className="td-div col-md-3">
                                        {/*<FormattedMessage id="app.image-slider.quotation.manufacture."*/}
                                        {/*defaultMessage=""*/}
                                        {/*description=""/>*/}
                                        <div>
                                            <img src={newm6} className="image-size"/>
                                        </div>
                                    </td>
                                </tr>

                                <tr>
                                    <td className="td-div2 col-md-2">
                                        <p>最小ビア径</p>
                                    </td>
                                    <td className="td-div2 custom-col-manufacture-1">
                                        <p>0.2mm</p>
                                    </td>
                                    <td className="td-div1 custom-col-manufacture-2  set-padding-manufacture-web">
                                        <p>片面、両面基板の場合最小ビア径Φ0.3/0.6mm <br/>多層基板の場合最小ビア径Φ0.2mm/0.45mm</p>
                                    </td>
                                    <td className="td-div col-md-3">
                                        {/*<FormattedMessage id="app.image-slider.quotation.manufacture."*/}
                                        {/*defaultMessage=""*/}
                                        {/*description=""/>*/}
                                        <div>
                                            <img src={newm7} className="image-size"/>
                                        </div>
                                    </td>
                                </tr>

                                <tr>
                                    <td className="td-div2 col-md-2">
                                        <p>最小ランド径</p>
                                    </td>
                                    <td className="td-div2 custom-col-manufacture-1">
                                        <p>0.45mm</p>
                                    </td>
                                    <td className="td-div1 custom-col-manufacture-2  set-padding-manufacture-web">
                                        <p>片面、両面基板の場合最小ランド径0.6mm<br/>多層基板の場合最小ランド径0.45mm</p>
                                    </td>
                                    <td className="td-div col-md-3">
                                        {/*<FormattedMessage id="app.image-slider.quotation.manufacture."*/}
                                        {/*defaultMessage=""*/}
                                        {/*description=""/>*/}
                                        <div>
                                            <img src={newm8} className="image8-size"/>
                                        </div>
                                    </td>
                                </tr>

                                <tr>
                                    <td className="td-div2 col-md-2">
                                        <p>最小パターン間隔</p>
                                    </td>
                                    <td className="td-div2 custom-col-manufacture-1">
                                        <p>0.127mm</p>
                                    </td>
                                    <td className="td-div1 custom-col-manufacture-2  set-padding-manufacture-web">
                                        <p>パターン-ランド間隔ランド-ランド間隔</p>
                                    </td>
                                    <td className="td-div col-md-3">
                                        {/*<FormattedMessage id="app.image-slider.quotation.manufacture."*/}
                                        {/*defaultMessage=""*/}
                                        {/*description=""/>*/}
                                        <img src={newm9} className="image-size"/>
                                    </td>
                                </tr>

                                <tr>
                                    <td className="td-div2 col-md-2">
                                        <p>ドリル穴サイズ</p>
                                    </td>
                                    <td className="td-div2 custom-col-manufacture-1">
                                        <p>0.2mm ～ 6.3mm</p>
                                    </td>
                                    <td className="td-div1 custom-col-manufacture-2  set-padding-manufacture-web">
                                        {/*<FormattedMessage id="app.image-slider.quotation.manufacture."*/}
                                        {/*defaultMessage=""*/}
                                        {/*description=""/>*/}
                                    </td>
                                    <td className="td-div col-md-3">
                                        {/*<FormattedMessage id="app.image-slider.quotation.manufacture."*/}
                                        {/*defaultMessage=""*/}
                                        {/*description=""/>*/}
                                        <div>
                                            <img src={newm10} className="image-size"/>
                                        </div>
                                    </td>
                                </tr>

                                <tr>
                                    <td className="td-div2 col-md-2">
                                        <p>ドリル穴径公差</p>
                                    </td>
                                    <td className="td-div2 custom-col-manufacture-1">
                                        <p>±0.08mm</p>
                                    </td>
                                    <td className="td-div1 custom-col-manufacture-2  set-padding-manufacture-web">
                                        <p>例)<br/>0.6 mmの穴の場合、0.52 mm から0.68 mmの間の<br/>仕上がり穴サイズが許容されます。</p>
                                    </td>
                                    <td className="td-div col-md-3">
                                        {/*<FormattedMessage id="app.image-slider.quotation.manufacture."*/}
                                        {/*defaultMessage=""*/}
                                        {/*description=""/>*/}
                                    </td>
                                </tr>

                                <tr>
                                    <td className="td-div2 col-md-2">
                                        <p>アニュアリング</p>
                                    </td>
                                    <td className="td-div2 custom-col-manufacture-1">
                                        <p>0.153mm以上</p>
                                    </td>
                                    <td className="td-div1 custom-col-manufacture-2  set-padding-manufacture-web">
                                        <p>ランド径とドリルビット径の差</p>
                                    </td>
                                    <td className="td-div col-md-3">
                                        {/*<FormattedMessage id="app.image-slider.quotation.manufacture."*/}
                                        {/*defaultMessage=""*/}
                                        {/*description=""/>*/}
                                        <div>
                                            <img src={newm11} className="image11-size"/>
                                        </div>
                                    </td>
                                </tr>

                                <tr>
                                    <td className="td-div2 col-md-2">
                                        <p>シルクカラー</p>
                                    </td>
                                    <td className="td-div2 custom-col-manufacture-1">
                                        <p>黒、白</p>
                                    </td>
                                    <td className="td-div1 custom-col-manufacture-2  set-padding-manufacture-web">
                                        <p>シルクの色指定はできません。<br/>レジストカラーにて決まります。</p>
                                    </td>
                                    <td className="td-div2 col-md-3 register-manufac">
                                        <p>レジストカラー<br/>緑、赤、黄、青、黒を選択した場合シルクは白色。<br/>白を選択した場合シルクは黒色。</p>
                                    </td>
                                </tr>

                                <tr>
                                    <td className="td-div2 col-md-2">
                                        <p>シルク文字幅</p>
                                    </td>
                                    <td className="td-div2 custom-col-manufacture-1">
                                        <p>最小0.153mm</p>
                                    </td>
                                    <td className="td-div1 custom-col-manufacture-2  set-padding-manufacture-web">
                                        <p>0.153mm未満の文字幅は識別出来ません。</p>
                                    </td>
                                    <td className="td-div col-md-3">
                                        {/*<FormattedMessage id="app.image-slider.quotation.manufacture."*/}
                                        {/*defaultMessage=""*/}
                                        {/*description=""/>*/}
                                        <div>
                                            <img src={newm12} className="image-size"/>
                                        </div>
                                    </td>
                                </tr>

                                <tr>
                                    <td className="td-div2 col-md-2">
                                        <p>シルク文字高</p>
                                    </td>
                                    <td className="td-div2 custom-col-manufacture-1">
                                        <p>最小1.0mm</p>
                                    </td>
                                    <td className="td-div1 custom-col-manufacture-2  set-padding-manufacture-web">
                                        <p>1.0mm 未満の文字高は識別来ません。</p>
                                    </td>
                                    <td className="td-div col-md-3">
                                        {/*<FormattedMessage id="app.image-slider.quotation.manufacture."*/}
                                        {/*defaultMessage=""*/}
                                        {/*description=""/>*/}
                                        <div>
                                            <img src={newm13} className="image13-size"/>
                                        </div>
                                    </td>
                                </tr>

                                <tr>
                                    <td className="td-div2 col-md-2">
                                        <p>外形形状（単品）</p>
                                    </td>
                                    <td className="td-div2 custom-col-manufacture-1">
                                        <p>0.3mm以上</p>
                                    </td>
                                    <td className="td-div1 custom-col-manufacture-2  set-padding-manufacture-web">
                                        <p>基板端面から銅箔部(パターン、ベタ)まで<br/>0.3mm 以上離してください。</p>
                                    </td>
                                    <td className="td-div col-md-3">
                                        {/*<FormattedMessage id="app.image-slider.quotation.manufacture."*/}
                                        {/*defaultMessage=""*/}
                                        {/*description=""/>*/}
                                        <div>
                                            <img src={newm14} className="image14-size"/>
                                        </div>
                                    </td>
                                </tr>

                                <tr>
                                    <td className="td-div2 col-md-2">
                                        <p>外形形状（シート）</p>
                                    </td>
                                    <td className="td-div2 custom-col-manufacture-1">
                                        <p>1.0mm以上</p>
                                    </td>
                                    <td className="td-div1 custom-col-manufacture-2  set-padding-manufacture-web">
                                        <p>V カットセンターから銅箔部(パターン、ベタ)まで <br/>1.0mm 以上離してください。</p>
                                    </td>
                                    <td className="td-div col-md-3">
                                        {/*<FormattedMessage id="app.image-slider.quotation.manufacture."*/}
                                        {/*defaultMessage=""*/}
                                        {/*description=""/>*/}
                                        <div>
                                            <img src={newm15} className="image-size"/>
                                        </div>
                                    </td>
                                </tr>

                                <tr>
                                    <td className="td-div2 col-md-2">
                                        <p>外形線幅</p>
                                    </td>
                                    <td className="td-div2 custom-col-manufacture-1">
                                        <p>0.2mm</p>
                                    </td>
                                    <td className="td-div1 custom-col-manufacture-2  set-padding-manufacture-web">
                                        <p>外形ガーバーデータに、線幅 0.2mm 外形ガーバー<br/>データに描かれた、線の中心を切削します。</p>
                                    </td>
                                    <td className="td-div col-md-3">
                                        {/*<FormattedMessage id="app.image-slider.quotation.manufacture."*/}
                                        {/*defaultMessage=""*/}
                                        {/*description=""/>*/}
                                    </td>
                                </tr>

                                <tr>
                                    <td className="td-div2 col-md-2">
                                        <p>Vカット線幅</p>
                                    </td>
                                    <td className="td-div2 custom-col-manufacture-1">
                                        {/*<FormattedMessage id="app.image-slider.quotation.manufacture."*/}
                                        {/*defaultMessage=""*/}
                                        {/*description=""/>*/}
                                    </td>
                                    <td className="td-div1 custom-col-manufacture-2  set-padding-manufacture-web">
                                        <p>外形線ガーバーデータ内に、線幅 +0.5mm の<br/>V カット線を作成してください。<br/>※V カット線の中心を基板端面としてカット。</p>
                                    </td>
                                    <td className="td-div col-md-3">
                                        {/*<FormattedMessage id="app.image-slider.quotation.manufacture."*/}
                                        {/*defaultMessage=""*/}
                                        {/*description=""/>*/}
                                    </td>
                                </tr>

                                <tr>
                                    <td className="td-div2 col-md-2">
                                        <p>シート形状</p>
                                    </td>
                                    <td className="td-div2 custom-col-manufacture-1">
                                        <p>3.0mm以上</p>
                                    </td>
                                    <td className="td-div1 custom-col-manufacture-2  set-padding-manufacture-web">
                                        <p>同種異種問わず複数面付けされたデータでルータ<br/>ーによる外形加工する場合は基板と基板の間隔は<br/>3.0mm 以上あけて配置してください。
                                        </p>
                                    </td>
                                    <td className="td-div col-md-3">
                                        {/*<FormattedMessage id="app.image-slider.quotation.manufacture."*/}
                                        {/*defaultMessage=""*/}
                                        {/*description=""/>*/}
                                        <div>
                                            <img src={newm16} className="image16-size"/>
                                        </div>
                                    </td>
                                </tr>

                                <tr>
                                    <td className="td-div2 col-md-2">
                                        <p>捨て基板</p>
                                    </td>
                                    <td className="td-div2 custom-col-manufacture-1">
                                        <p>3.0mm以上</p>
                                    </td>
                                    <td className="td-div1 custom-col-manufacture-2  set-padding-manufacture-web">
                                        <p>3.0mmの場合、分割する際に困難になりますので、余裕を持って5.0mm以上で設計することを推奨します。実装認識マークを配置する場合は捨て基板は、10.0mmで設計することを推奨します。</p>
                                    </td>
                                    <td className="td-div col-md-3">
                                        {/*<FormattedMessage id="app.image-slider.quotation.manufacture."*/}
                                        {/*defaultMessage=""*/}
                                        {/*description=""/>*/}
                                        <div>
                                            <img src={newm17} className="image-size"/>
                                        </div>
                                    </td>
                                </tr>


                            </table>
                        </div>
                        {/*<div className='col-md-10'></div>*/}
                        {/*<div className='col-md-2'>*/}
                        {/*<Link to="/companyProfile">*/}
                        {/*<span className='font-size-20'>*/}
                        {/*バック*/}
                        {/*</span>*/}
                        {/*</Link>*/}
                        {/*</div>*/}
                        {/*<div className='col-md-1 table-block-manufacture'></div>*/}
                    </div>
                </div>

            </div>
        );
    }
}

export default ManufactureDocument;



// WEBPACK FOOTER //
// ./src/components/Site/HomeContent/ImageSlider/ImageSliderQuotation/SliderQuotationContent3/ManufactureDocument.js